module.exports = __webpack_public_path__ + "static/media/86.f4b7e173.png";